<p-toast></p-toast>

<customer-info *ngIf="isVisibleCustomerInfo"
               [isVisibleCustomerInfo]="isVisibleCustomerInfo"
               [_customerId]="customerId"
               (changedVisibleCustomerInfoEmit)="changedVisibleCustomerInfoEmit($event)"></customer-info>

<p-sidebar [(visible)]="isVisibleDisplayOrderDetail"
           [position]="'right'"
           [baseZIndex]="11000"
           (onHide)="cancel()"
           [style]="{width:'790px'}">

    <ng-template pTemplate="header">
        <div class="order-details-head-font" *ngIf="riderId > 0">Ride ID: {{riderOrderDetail?.Id}}</div>
        <div *ngIf="riderId <= 0">Order</div>
    </ng-template>

    <div class="bg-menu">
        <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="menuItems[0]"></p-tabMenu>
    </div>

    <div *ngIf="riderOrderDetail">
        <div *ngIf="activeTab === menuTab.OrderDetail" class="orderdetail-block">
            <div class="mt-3 ml-2 flex flex-column">
                <div class="order-details-payment-head">Xpress Transaction</div>
                <div class="ml-2 mt-3 flex flex-row flex-wrap">
                    <div class="col-6 p-0 col-w45">
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Transaction date:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionDate}}</div>
                            <div class="col-6 p-0 mb-2">Transaction type:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.OperationTypeText}}</div>
                        </div>
                    </div>
                    <div class="ml-4 col-6 p-0 w-50-percent">
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-2">Transaction time:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionTime}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-5 ml-2 flex flex-column">
                <div class="order-details-payment-head">Customer Promotions</div>
                <div class="ml-2 mt-3 flex flex-row flex-wrap">
                    <div class="col-6 p-0 col-w45">
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Promo Used?</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{riderOrderDetail.PromoName ? 'Yes' : 'No'}}</div>
                            <div class="col-6 p-0 mb-2">Promo Amount:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">₱ {{riderOrderDetail.PromoAmount}}</div>
                        </div>
                    </div>
                    <div class="ml-4 col-6 p-0 w-50-percent">
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Promo</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{riderOrderDetail.PromoCode}}</div>
                            <div class="col-6 p-0 mb-2">Promo Funding:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">Xpress</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-5 ml-2 flex flex-column">
                <div class="order-details-payment-head">Payment</div>
                <div class="flex flex-row flex-wrap">
                    <div class="col-6 p-0 col-w45">
                        <div class="ml-2 mt-3 flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Payment method:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">
                                {{(bookingTransactionDetails.PaymentMethodText) ? bookingTransactionDetails.PaymentMethodText : 'N/A'}}
                            </div>
                            <div class="col-6 p-0 mb-2">Transaction amount:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionAmountText}}</div>
                        </div>
                    </div>
                    <div class="col-6 p-0 w53">
                        <div class="ml-5 mt-3 flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Partner TX ID:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">
                                <span class="lm-active-order-link">{{bookingTransactionDetails.PartnerTXID | slice:0:18}}</span>
                            </div>
                            <div class="col-6 p-0 mb-4">Transaction status:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">
                                <span class="badge" [ngStyle]="getStatusStyles(bookingTransactionDetails.Status)">{{bookingTransactionDetails.Status}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row flex-wrap">
                    <div class="col-12 p-0">
                        <div class="ml-2 mt-3 flex flex-row flex-wrap">
                            <div class="col-5 p-0 mb-3">Total Fare</div>
                            <div class="col-6 p-0 mb-1 ml-6 pl-2">{{riderOrderDetail.InitialTotalFareAmount}}</div>

                            <div class="col-11 p-0 flex ml-3">
                                <div class="col-6 p-0 mb-2">Waiting Fee</div>
                                <div class="col-6 p-0 mb-2 ml-2">{{riderOrderDetail.WaitingFeeAmountText}}</div>
                            </div>
                            <div class="col-11 p-0 flex ml-3">
                                <div class="col-6 p-0 mb-2">Ride Insurance Opt-in</div>
                                <div class="col-6 p-0 mb-2 ml-2">₱ {{riderOrderDetail.RiderInsuranceAmount}}</div>
                            </div>
                            <div class="col-11 p-0 flex ml-3">
                                <div class="col-6 p-0 mb-2">Demand Surcharge</div>
                                <div class="col-6 p-0 mb-2 ml-2">{{riderOrderDetail.SurgeCharges}}</div>
                            </div>
                            <div class="col-11 p-0 flex ml-3">
                                <div class="col-6 p-0 mb-2">Distance Fee</div>
                                <div class="col-6 p-0 mb-2 ml-2">{{riderOrderDetail.DistanceFare}}</div>
                            </div>
                            <div class="col-11 p-0 flex ml-3" *ngIf="riderOrderDetail.PickupFareAmount">
                                <div class="col-6 p-0 mb-2">Pickup Fare</div>
                                <div class="col-6 p-0 mb-2 ml-2">{{riderOrderDetail.PickupFareAmountText}}</div>
                            </div>
                            <div class="col-11 p-0 flex ml-3">
                                <div class="col-6 p-0 mb-2">Commission</div>
                                <div class="col-6 p-0 mb-3 ml-2">{{riderOrderDetail.ServiceFeeAmount}}</div>
                            </div>

                            <div class="col-11 p-0 flex">
                                <div class="col-6 p-0 mb-3">Promo</div>
                                <div class="col-6 p-0 mb-3 ml-4">₱ {{riderOrderDetail.PromoAmount}}</div>
                            </div>
                            <div class="col-11 p-0 flex">
                                <div class="col-6 p-0 mb-3">Tip</div>
                                <div class="col-6 p-0 mb-3 ml-4">{{riderOrderDetail.TipAmount}}</div>
                            </div>
                            <div class="col-11 p-0 flex">
                                <div class="col-6 p-0 mb-3">Amount Paid</div>
                                <div class="col-6 p-0 mb-3 ml-4">{{riderOrderDetail.Amount}}</div>
                            </div>
                            <div class="col-11 p-0 flex">
                                <div class="col-6 p-0 mb-3">Xpress Service</div>
                                <div class="col-6 p-0 mb-3 ml-4">{{riderOrderDetail.ServiceFeeAmount}}</div>
                            </div>
                            <div class="col-11 p-0 flex">
                                <div class="col-6 p-0 mb-3">Driver Earnings</div>
                                <div class="col-6 p-0 mb-3 ml-4">₱ {{riderOrderDetail.NetFare}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 ml-2 flex flex-column">
                <div class="order-details-payment-head">Product & Services</div>
                <div class="ml-2 mt-3 flex flex-row flex-wrap">
                    <div class="col-6 p-0 col-w45">
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Service</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{riderOrderDetail.ServiceTypeText}} | {{riderOrderDetail.VehicleTypeText}}</div>
                        </div>
                    </div>
                    <div class="ml-4 col-6 p-0 w-50-percent">
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Products</div>
                            <div class="col-6 p-0 mb-2 transaction-value">---</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 ml-2 flex flex-column">
                <div class="order-details-payment-head">Corresponding Identifiers</div>
                <div class="ml-2 mt-3 flex flex-row flex-wrap">
                    <div class="col-6 p-0 col-w45">
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Booking ID:</div>
                            <div class="col-6 p-0 mb-2 transaction-value lm-active-order-details-value-link">{{riderOrderDetail.Id}}</div>
                        </div>
                    </div>
                    <div class="ml-4 col-6 p-0 w-50-percent">
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Order ID:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">---</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 ml-2 flex flex-column" *ngIf="!isOperatorAccount">
                <div class="order-details-payment-head">Booking Details</div>
                <div class="mt-3 ml-2 col-12 p-0">
                    <div class="flex flex-row flex-wrap">
                        <div class="col-6 p-0 mb-4 w48">Pickup</div>
                        <div class="col-6 p-0 mb-2">
                            <div>{{riderOrderDetail.PickupAddress?.BuildingName}}</div>
                            <div class="order-details-payment-small">{{riderOrderDetail.PickupAddress?.Address}}</div>
                        </div>
                    </div>
                </div>
                <div class="mt-3 ml-2 col-12 p-0">
                    <div class="flex flex-row flex-wrap">
                        <div class="col-6 p-0 mb-4 w48">Drop Off</div>
                        <ng-container *ngFor="let dropoff of riderOrderDetail.DropoffOrderPoints; let i = index;">
                            <div class="col-6 p-0 mb-2">
                                <div>{{dropoff.BuildingName}}</div>
                                <div class="order-details-payment-small">{{dropoff.Address}}</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="activeTab === menuTab.Customer && !isOperatorAccount" class="order-customer-block">
            <div class="lm-active-order-details-main-block">
                <div class="flex flex-row" style="justify-content: space-between;">
                    <div class="left-img-block">
                        <img class="user-img" *ngIf="riderOrderDetail.UserImageUrl; else placeholder" src="{{riderOrderDetail.UserImageUrl}}" />
                        <ng-template #placeholder>
                            <img class="user-img" src="/XpressApp/assets/images/avatar_placeholder.svg" />
                        </ng-template>

                        <div class="ml-5" style="margin-top: -45px;">
                            <div class="lm-left-block">Name:</div>
                            <div class="lm-left-block">Sign up:</div>
                            <div class="lm-left-block">Phone:</div>
                            <div class="lm-left-block">Rating:</div>
                            <div class="lm-left-block">Account:</div>
                            <div class="lm-left-block">Application:</div>
                        </div>
                    </div>
                    <div class="text-right">
                        <div class="lm-right-block">
                            <span class="lm-active-order-link" (click)="handleCustomerInfoClick(riderOrderDetail.UserId)">
                                {{riderOrderDetail.UserFirstName}} {{riderOrderDetail.UserLastName | slice:0:1}}.
                            </span>
                        </div>
                        <div class="lm-right-block">{{riderOrderDetail.UserCreatedAtText}} ({{riderOrderDetail.UserSignUpDaysPassed}} days)</div>
                        <div class="flex lm-right-block">
                            <div class="mr-8">{{riderOrderDetail.UserPhoneMask}}&nbsp;</div>
                            <div class="badge verified" style="margin-top: -8px;" [ngClass]="{'verified': isPhoneNumberVerified}">Verified</div>
                        </div>
                        <div class="lm-right-block">
                            <span class="star-icon" style="margin-top: -6px;">&#9733;</span> {{riderOrderDetail.UserRating}}
                        </div>
                        <div class="lm-right-block">
                            <span class="lm-active-order-link">{{(riderOrderDetail.LoginProvider) ? riderOrderDetail.LoginProvider : 'Xpress'}}</span>
                        </div>
                        <div class="lm-right-block">
                            <span class="badge xpress-app" style="margin-right: 140px">Xpress App</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="lm-active-order-details-main-block mt-3">
                <div class="lm-active-order-details-field-block">
                    <div class="lm-active-order-details-field-name">Bookings:</div>
                    <div class="lm-active-order-details-field-value">{{riderOrderDetail.BookingsCount}}</div>
                </div>
                <div class="lm-active-order-details-field-block">
                    <div class="lm-active-order-details-field-name">Completed:</div>
                    <div class="lm-active-order-details-field-value">{{riderOrderDetail.CompletedCount}} ({{riderOrderDetail.CompletedPercent}}%)</div>
                </div>
                <div class="lm-active-order-details-field-block">
                    <div class="lm-active-order-details-field-name">Spend:</div>
                    <div class="lm-active-order-details-field-value">{{riderOrderDetail.TotalSpendText}}</div>
                </div>
                <div class="lm-active-order-details-field-block">
                    <div class="lm-active-order-details-field-name">Priority:</div>
                    <div class="lm-active-order-details-field-value badge regular" [ngClass]="{'vip': riderOrderDetail.IsPriority}">{{getPriority()}}</div>
                </div>
            </div>
        </div>

        <div *ngIf="activeTab === menuTab.Payment" class="mt-3">
            <div class="mt-3 ml-2 flex flex-column">
                <div class="order-details-payment-head">Xpress Transaction</div>
                <div class="ml-2 mt-3 flex flex-row flex-wrap">
                    <div class="col-6 p-0 col-w45">
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Transaction date:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionDate}}</div>
                            <div class="col-6 p-0 mb-2">Transaction type:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.OperationTypeText}}</div>
                        </div>
                    </div>
                    <div class="ml-4 col-6 p-0 w-50-percent">
                        <div class="flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-2">Transaction time:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionTime}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-5 ml-2 flex flex-column">
                <div class="order-details-payment-head">Payment</div>
                <div class="flex flex-row flex-wrap">
                    <div class="col-6 p-0 col-w45">
                        <div class="ml-2 mt-3 flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Payment method:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">
                                {{(bookingTransactionDetails.PaymentMethodText) ? bookingTransactionDetails.PaymentMethodText : 'N/A'}}
                            </div>
                            <div class="col-6 p-0 mb-2">Transaction amount:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionAmountText}}</div>
                        </div>
                    </div>
                    <div class="col-6 p-0 w53">
                        <div class="ml-5 mt-3 flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Partner TX ID:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">
                                <span class="lm-active-order-link">{{bookingTransactionDetails.PartnerTXID | slice:0:18}}</span>
                            </div>
                            <div class="col-6 p-0 mb-4">Transaction status:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">
                                <span class="badge" [ngStyle]="getStatusStyles(bookingTransactionDetails.Status)">{{bookingTransactionDetails.Status}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-3 ml-2 flex flex-column">
                <div class="order-details-payment-head">Payment Processor</div>
                <div class="flex flex-row flex-wrap">
                    <div class="col-6 p-0 col-w45">
                        <div class="ml-2 mt-3 flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Partner:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">Xendit</div>
                            <div class="col-6 p-0 mb-4">Transaction time:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionTime}}</div>
                        </div>
                    </div>
                    <div class="col-6 p-0 w53">
                        <div class="ml-5 mt-3 flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Reference:</div>
                            <div class="lm-active-order-link ml-auto">{{bookingTransactionDetails.Id}}</div>
                            <div class="col-6 p-0 mb-2">Transaction status:</div>
                            <div class="col-6 p-0 mb-4 transaction-value">
                                <span class="badge" [ngStyle]="getStatusStyles(bookingTransactionDetails.Status)">{{bookingTransactionDetails.Status}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-3 ml-2 flex flex-column">
                <div class="order-details-payment-head">Wallet History</div>
                <div class="flex flex-row flex-wrap">
                    <div class="col-6 p-0 w98">
                        <div class="ml-2 mt-3 flex flex-row flex-wrap">
                            <div class="col-6 p-0 mb-4">Previous balance:</div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{riderOrderDetail.PreviousWalletBalance}}</div>
                            <div class="col-6 p-0 mb-4">New Balance:<div class="order-details-payment-small">(After Top up)</div></div>
                            <div class="col-6 p-0 mb-2 transaction-value">{{riderOrderDetail.CurrentWalletBalance}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="activeTab === menuTab.Timeline && !isOperatorAccount" class="ml-3 mt-3">
            <div class="order-details-payment-head">Order Timeline</div>
            <div class="ml-1 flex flex-row flex-wrap">
                <div class="col-6 p-0 col-w45">
                    <div class="ml-2 mt-3 flex flex-row flex-wrap">
                        <div class="col-6 p-0 mb-4">Date:</div>
                        <div class="col-6 p-0 mb-2 transaction-value">{{bookingTransactionDetails.TransactionDate}}</div>
                        <div class="col-6 p-0 mb-4">Session Time:</div>
                        <div class="col-6 p-0 mb-2 transaction-value">{{riderOrderDetail.SessionTime}}</div>
                        <div class="col-6 p-0 mb-4">Attempts:</div>
                        <div class="col-6 p-0 mb-2 transaction-value">{{riderOrderDetail.AttemptCounts}}</div>

                        <ng-container *ngFor="let orderAttempt of riderOrderDetail.OrderAttempts; let i = index;">
                            <div class="col-6 p-0 mb-4">{{orderAttempt.CreatedAt}}</div>
                            <div class="col-3 p-0 mb-4">Single</div>
                            <div class="col-3 p-0 mb-4 transaction-value" [ngClass]="{'green-color': orderAttempt.OrderRiderAction === orderRiderActionEnum.Accept}">{{orderAttempt.OrderRiderActionText}}</div>
                        </ng-container>
                    </div>
                </div>

                <div class="col-6 p-0 col-w45">
                    <div class="flex">
                        <div class="ml-5 step flex passed-step col-3 p-0">
                            <img src="../Content/xpress-app/images/operator/signup/signup-step-check.svg"/>
                        </div>
                        <div class="col-4 p-0 ml-3 step-text mt-2px">Time Accepted</div>
                        <div class="col-6 p-0 ml-7 step-text transaction-value mt-2px">{{bookingTransactionDetails.TransactionTimeNoSeconds}}</div>
                    </div>
                    <div class="vertical-steps-line"></div>
                    <div class="flex">
                        <div class="ml-5 step flex current-step col-3 p-0"></div>
                        <div class="col-7 p-0 ml-3 step-text mt-2px">Time Arrival on Pick up point</div>
                        <div class="col-3 p-0 ml-7 step-text transaction-value mt-2px">{{riderOrderDetail.ArrivedToPickupTime}}</div>
                    </div>
                    <div class="vertical-steps-line"></div>
                    <div class="flex">
                        <div class="ml-5 step flex current-step col-3 p-0"></div>
                        <div class="col-7 p-0 ml-3 step-text mt-2px">Time Arrival on Drop off point</div>
                        <div class="col-3 p-0 ml-7 step-text transaction-value mt-2px">{{riderOrderDetail.DroppedOffTime}}</div>
                    </div>
                    <div class="vertical-steps-line"></div>
                    <div class="flex">
                        <div class="ml-5 step flex current-step col-3 p-0"></div>
                        <div class="col-7 p-0 ml-3 step-text">Time of Drop off</div>
                        <div class="col-3 p-0 ml-7 step-text transaction-value">{{riderOrderDetail.DroppedOffTime}}</div>
                    </div>
                </div>
            </div>

            <hr class="p-1 lm-active-order-details-hr" />
            <div class="mb-4 map-placeholder"></div>
            <hr class="p-1 lm-active-order-details-hr" />

            <div class="mt-3">
                <div class="flex flex-row">
                    <div class="vertical-dotted-line">
                        <img src="/XpressApp/assets/images/live-map-icons/pickup.svg" />
                        <img src="/XpressApp/assets/images/live-map-icons/destination.svg" />
                    </div>
                    <div class="ml-2">
                        <div class="route-point-font">Pick Up</div>
                        <div class="route-point-building-name">{{riderOrderDetail.PickupAddress?.BuildingName}}</div>
                        <div class="route-point-address">{{riderOrderDetail.PickupAddress?.Address}}</div>

                        <div class="route-point-font mt-3">Destination</div>
                        <div class="route-point-building-name">{{riderOrderDetail.DropoffOrderPoints[riderOrderDetail.DropoffOrderPoints.length-1]?.BuildingName}}</div>
                        <div class="route-point-address">{{riderOrderDetail.DropoffOrderPoints[riderOrderDetail.DropoffOrderPoints.length-1]?.Address}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="activeTab === menuTab.Messages && !isOperatorAccount">
        <div class="order-detail-chat-title">
            Driver and Customer Messages
        </div>

        <div *ngFor="let item of riderOrderDetail.OrderChats">
            <div class="order-detail-block-message-rider" *ngIf="item.MessageTypeId === chatMessageType.RiderToCustomer">
                <div class="w-70">
                    <div class="message-author">{{item.RiderFullName}}</div>
                    <div class="order-detail-chat-message-rider message-text-left">{{item.Message}}</div>
                    <div class="message-date flex justify-content-end">{{item.CreatedAt}}</div>
                </div>
            </div>
            <div class="order-detail-block-message-passenger" *ngIf="item.MessageTypeId === chatMessageType.CustomerToRider">
                <div class="w-70">
                    <div class="message-author flex justify-content-end">{{item.CustomerFullName}}</div>
                    <div class="order-detail-chat-message-passenger message-text-right">{{item.Message}}</div>
                    <div class="message-date ">{{item.CreatedAt}}</div>
                </div>
            </div>
        </div>
    </div>

</p-sidebar>
